export default "__VITE_ASSET__e0d567d3__"